<div *ngIf="complite">
    <h5>People count {{genderCount.male.value + genderCount.female.value + genderCount.undefined.value}}</h5>
</div>

